/*
 * @Author: Dong
 * @Date: 2022-05-05 16:14:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-04-17 15:18:22
 */
import React, { useEffect } from 'react';

import Welcome from './components/Welcome';
import List from './components/List';
import { useSelector, useDispatch } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { common } from 'root/store/actions';
import { getSuposInstanceApi } from 'root/services/packageManage';

import styles from './index.less';

const MultipleInstances = () => {
  const dispath = useDispatch();
  useEffect(() => {
    getSuposInstanceApi().then((res) => {
      dispath(common.updateSuposDir({ hasSuposCatalogue: res.data }));
      sessionStorage.setItem('hasSuposCatalogue', res.data ? 'true' : '');
    });
  }, []);
  const { hasSuposCatalogue } = useSelector((state: reducerStates) => state.common);

  return <div className={styles.container}>{hasSuposCatalogue ? <List /> : <Welcome />}</div>;
};

export default MultipleInstances;
